// Copyright (c) StrangeBee 2023

import React, { ReactElement } from 'react';
import { ResultCard } from '@Organisms/Search/SearchResultCard/ResultCard';
import { extractData } from './extractData';
import { useLocalMessage } from '@Helpers/locale';
import { ICONS } from '@Constants/iconsApp';
import { PatternType } from '@Constants/patternsRoute';
import RouteBuilder from '@Services/RouteBuilder';
import { AlertOutput, CaseOutput } from 'thehive-sdk';

import './JobResultCard.scss';

interface JobResultCardProps {
    data?: any;
}

export const JobResultCard = ({ data }: JobResultCardProps): ReactElement => {
    const i = useLocalMessage();

    const {
        analyzerName,
        startDate,
        endDate,
        cortexId,
        status,
        extraData: { links },
    } = data || {};

    const { _id: idObservable, alert: alertData, case: caseData } = links || {};

    const parentType = caseData ? 'case' : alertData ? 'alert' : 'observable';

    let paramsUrl = [] as unknown[];
    let source = {
        title: '',
        icon: <ICONS.CaseIcon />,
        path: '',
    };

    switch (parentType) {
        case 'alert':
            paramsUrl = ['alerts.observables' as PatternType, { alertId: alertData?._id }];
            source = {
                title: (alertData as AlertOutput).title,
                icon: <ICONS.AlertIcon />,
                path: RouteBuilder.compute('alerts.details', { alertId: alertData?._id }),
            };
            break;
        case 'case':
            paramsUrl = ['cases.observable' as PatternType, { caseId: caseData?._id, observableId: idObservable }];
            source = {
                title: (caseData as CaseOutput).title,
                icon: <ICONS.CaseIcon />,
                path: RouteBuilder.compute('cases.details', { caseId: caseData?._id }),
            };
            break;
        case 'observable':
            paramsUrl = [];
            break;
    }

    const path = paramsUrl.length
        ? RouteBuilder.compute(...(paramsUrl as [PatternType, Record<string, string>]))
        : undefined;

    return (
        <ResultCard
            data={{
                '#computeTitle': {
                    title: `${analyzerName} [${cortexId}]`,
                    icon: <ICONS.JobIcon />,
                    path,
                },
                '#computeSource': {
                    ...source,
                },
                '#computeDate': {
                    dateStart: startDate,
                    dateEnd: endDate,
                },
                status,
            }}
            extract={extractData({ locale: i })}
        />
    );
};
